export default function getViewLogicTabId(viewId: number): string {
  return `page:${viewId}`;
}
